








import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";

@Component({})
export default class ImagePreview extends Vue {
  open = false;
  imageUrl: string | null = null;

  @Watch("open")
  onOpen(open: boolean) {
    if (document.scrollingElement)
      if (open) {
        document.scrollingElement.setAttribute("style", "overflow-y: hidden");
      } else {
        document.scrollingElement.setAttribute("style", "overflow-y: auto");
      }
  }

  abrir(url: string) {
    this.imageUrl = url;
    this.open = true;
  }
}
